import React, { useEffect, useState } from 'react';
import NumberInput from '../../components/NumberInput/NumberInput';
import './Button.css'
import DeclineModal from '../DeclineModal/DeclineModal';


export default function Button() {
  const [showNumberInput, setShowNumberInput] = useState<any>(false);
  const [showButtonSection, setShowButtonSection] = useState<any>(true);
  const [declineModalVisibility, setDeclineModalVisibility] = useState<any>(false);
// const showNumberInput=(e)=>{

// }
  // useEffect()

  const handleCloseTab = () => {
    setDeclineModalVisibility(true)  
  };

  return (
    <div>
      {showButtonSection?
      <div className='disclaimer-btn-wrapper' >
        <div className='btn-wrapper'>
        <button className='btn-primary' onClick={(e)=>{setShowNumberInput(true);setShowButtonSection(false)}}>Agree</button>
        </div>   
        <div className='btn-wrapper'>
        <button className='btn-secondary' onClick={handleCloseTab}>Decline</button>
        </div>  
      </div>:null}
        
        {showNumberInput?
          <NumberInput />:null
        }
        <DeclineModal visible={declineModalVisibility} handleClose={()=>setDeclineModalVisibility(false)}/>
    </div>
  )
}
